import { render } from "./settings-page.vue?vue&type=template&id=ba30b662"
import script from "./settings-page.vue?vue&type=script&lang=js"
export * from "./settings-page.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__